import React from "react";
import { Form, FormGroup, Label } from "reactstrap";
import PropTypes from "prop-types";

import { FormField, SelectFormField } from "../../../../../utils/FormFields";
import { OptionsWhyWithoutTIN } from "../../../../Profile/Person/types";

function FiscalResidence({ person, changedPerson, showChanges, remove }) {
  const showFiscalResidence = changedPerson || person;
  const editFiscalResidence = changedPerson.PersonFiscalResidence[0];
  let compareFiscalResidence = {};
  person.PersonFiscalResidence.forEach((d) => {
    if (
      parseInt(d.PersonFiscalResidenceId, 10) ===
      parseInt(editFiscalResidence.PersonFiscalResidenceId, 10)
    ) {
      compareFiscalResidence = d;
    }
  });
  let color = "black";
  if (showChanges) {
    if (compareFiscalResidence === undefined) {
      color = "green";
    } else {
      color = remove ? "red" : "#36a9e1";
    }
  }

  return (
    <Form>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "20px",
          display: "block",
          color,
        }}
      >
        {showChanges ? (
          <React.Fragment>
            {compareFiscalResidence !== undefined &&
              (editFiscalResidence.PersonFiscalResidenceId == 0
                ? "New Account"
                : remove
                ? "Remove Account"
                : "Edit Account")}
          </React.Fragment>
        ) : (
          "Actual Account"
        )}
      </Label>
      {showChanges ? (
        <FormGroup tag="fieldset">
          {compareFiscalResidence && (
            <FormToShow
              fiscalResidence={editFiscalResidence}
              refFiscalResidence={compareFiscalResidence}
            />
          )}
        </FormGroup>
      ) : (
        <FormGroup tag="fieldset">
          {compareFiscalResidence && (
            <FormToShow fiscalResidence={compareFiscalResidence} />
          )}
        </FormGroup>
      )}
    </Form>
  );
}

FiscalResidence.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object.isRequired,
  showChanges: PropTypes.bool.isRequired,
};

export default FiscalResidence;

const FormToShow = ({ fiscalResidence, refFiscalResidence }) => (
  <React.Fragment>
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceCountryName !== undefined && (
        <FormField
          label="Fiscal Residence Country: "
          value={fiscalResidence.PersonFiscalResidenceCountryName}
          name="PersonFiscalResidenceCountryName"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceCountryName !==
              refFiscalResidence.PersonFiscalResidenceCountryName
          }
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceTaxId !== undefined && (
        <SelectFormField
          label="Tin Type: "
          name="PersonFiscalResidenceTaxId"
          value={fiscalResidence.PersonFiscalResidenceTaxId}
          selectItems={[
            {
              DocumentTypeId: fiscalResidence.PersonFiscalResidenceTaxId,
              DocumentTypeName: fiscalResidence.PersonFiscalResidenceTaxIdName,
            },
          ]}
          getSelectItemId={(i) => i.DocumentTypeId}
          getSelectItemName={(i) => i.DocumentTypeName}
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceTin !== undefined && (
        <FormField
          label="Fiscal Residence TIN: "
          value={fiscalResidence.PersonFiscalResidenceTin}
          name="PersonFiscalResidenceTin"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceTin !==
              refFiscalResidence.PersonFiscalResidenceTin
          }
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceNoTINOpt !== undefined && (
        <SelectFormField
          label="Option: "
          value={fiscalResidence.PersonFiscalResidenceNoTINOpt}
          name="PersonFiscalResidenceNoTINOpt"
          selectItems={OptionsWhyWithoutTIN}
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceNoTINOpt !==
              refFiscalResidence.PersonFiscalResidenceNoTINOpt
          }
          getSelectItemId={(item) => item.id}
          getSelectItemName={(item) => item.text}
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceDateFrom !== undefined && (
        <FormField
          label="Date From: "
          value={
            fiscalResidence.PersonFiscalResidenceDateFrom ===
            "0000-00-00T00:00:00"
              ? new Date()
              : fiscalResidence.PersonFiscalResidenceDateFrom
          }
          name="PersonFiscalResidenceDateFrom"
          type="date"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceDateFrom !==
              refFiscalResidence.PersonFiscalResidenceDateFrom
          }
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceDateTo !== undefined && (
        <FormField
          label="Date To: "
          value={
            fiscalResidence.PersonFiscalResidenceDateTo ===
            "0000-00-00T00:00:00"
              ? new Date()
              : fiscalResidence.PersonFiscalResidenceDateTo
          }
          name="PersonFiscalResidenceDateTo"
          type="date"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceDateTo !==
              refFiscalResidence.PersonFiscalResidenceDateTo
          }
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceAddress !== undefined && (
        <FormField
          label="Address: "
          value={fiscalResidence.PersonFiscalResidenceAddress}
          name="PersonFiscalResidenceAddress"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceAddress !==
              refFiscalResidence.PersonFiscalResidenceAddress
          }
        />
      )}
    {fiscalResidence &&
      fiscalResidence.PersonFiscalResidenceNoTINSpecify !== undefined && (
        <FormField
          label="Option B Specify: "
          value={fiscalResidence.PersonFiscalResidenceNoTINSpecify}
          name="PersonFiscalResidenceNoTINSpecify"
          type="textarea"
          changedColor={
            refFiscalResidence &&
            refFiscalResidence.PersonFiscalResidenceNoTINSpecify !==
              refFiscalResidence.PersonFiscalResidenceNoTINSpecify
          }
        />
      )}
  </React.Fragment>
);

FormToShow.propTypes = {
  fiscalResidence: PropTypes.object.isRequired,
  refFiscalResidence: PropTypes.object,
};

FormToShow.defaultProps = {
  refFiscalResidence: undefined,
};
